<template>
  <div class="stacked-columns">
    <h3 class="stacked-columns__title"> Var kommer min sjukförsäkring ifrån? </h3>

    <div id="chartdiv"></div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: 'StackedColumns',
  props: [ 'graphData' ],
  methods: {
    createSeries(chart, valueY, name, color) {
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = valueY;
      series.dataFields.categoryX = "category";
      series.name = name;
      series.stacked = true;
      series.fill = am4core.color(color);
      series.stroke = am4core.color(color);
      series.cursorTooltipEnabled = false;
      series.columns.template.tooltipText = "{valueY}";

      return series
    }
  },
  mounted() {
    var chart = am4core.create("chartdiv", am4charts.XYChart);

    chart.data = this.graphData;

    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 100;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "Inkomst";

    this.createSeries(chart, 'salary', 'Arbetsgivaren', '#CB3159');
    this.createSeries(chart, 'fsk', 'Försäkringskassan', '#096424');
    this.createSeries(chart, 'sju', 'Försäkring', '#499CFE');
    this.createSeries(chart, 'no-income', 'Inkomstbortfall', '#F0F0F0');

    chart.cursor = new am4charts.XYCursor();

    chart.scrollbarX = new am4core.Scrollbar();

    chart.responsive.enabled = true;

    // Add legend
    chart.legend = new am4charts.Legend();
    chart.legend.itemContainers.template.clickable = false
    chart.legend.itemContainers.template.focusable = false
    chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}

</script>


<style lang="scss" scoped>
.stacked-columns {
  margin: 3rem 0;

  &__title {
    margin-bottom: 3rem;
  }
}

#chartdiv {
  width: 100%;
  height: 500px;
  font-family: "Roboto", sans-serif;
}
</style>